module.exports = __webpack_public_path__ + "media/images/patent/y_12-eba9040a46837acffa1f39ceb1a8499b.jpg";